// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__E5nyj","title":"BackImages_title__1mAIV","images":"BackImages_images__2HMbo"};